import { HttpService } from "@core/services/http.service.ts";
import {
  Permission,
  Profil,
  ProfilDTO,
  ProfilFormData,
  ProfilPutDTO,
  ProfilTransferDTO,
} from "./profil.model.ts";
import { apiURL } from "@utils/environment.ts";
import { PaginateResponse } from "@utils/appUtils.ts";
import { ApiMethod } from "@core/interfaces/api.ts";

export class ProfileService extends HttpService {
  private APIURL = apiURL;

  getAllProfils(params: {
    search?: string;
    page?: number;
    size?: number;
    sortBy?: string;
    sortDir?: string;
  }): Promise<PaginateResponse<ProfilDTO>> {
    const queryParams = new URLSearchParams({
      search: params.search?.toString() ?? "",
      page: params.page?.toString() ?? "",
      size: params.size?.toString() ?? "",
      sortBy: params.sortBy ?? "",
      sortDir: params.sortDir ?? "",
    });
    this.urlAPI = this.APIURL + `/profil?${queryParams}`;
    return this.doGet<PaginateResponse<ProfilDTO>>();
  }

  getProfilTransfer() {
    this.urlAPI = this.APIURL + "/profil/transfer";
    return this.doGet<ProfilTransferDTO[]>();
  }

  getProfilLookup() {
    this.urlAPI = this.APIURL + "/profil/lookup";
    return this.doGet<ProfilTransferDTO[]>();
  }

  saveProfile(profil: Profil) {
    this.urlAPI = this.APIURL + "/profil";
    return this.doPost<ProfilDTO, Profil>(profil);
  }
  deleteProfile(id: string) {
    this.urlAPI = this.APIURL + `/profil/${id}`;
    return this.doDelete<any>();
  }
  editProfile(id: string, profil: ProfilPutDTO) {
    this.urlAPI = this.APIURL + `/profil/${id}`;
    return this.doPut<any, ProfilPutDTO>(profil);
  }
  getProfilById(id: string) {
    this.urlAPI = this.APIURL + `/profil/${id}`;
    return this.doGet<ProfilDTO>();
  }
  getPermissions() {
    this.urlAPI = this.APIURL + "/permission";
    return this.doGet<Permission[]>();
  }
  getAccess() {
    this.urlAPI = this.APIURL + "/access";
    return this.doGet<Permission[]>();
  }
  
  saveProfilFormData(params: ProfilFormData) {
    const formData = new FormData();
    if (params.file) {
      formData.append("file", params.file);
    }
    const jsonBlob = new Blob([JSON.stringify(params.data)], {
      type: "application/json",
    });
    formData.append("data", jsonBlob);
    this.urlAPI = this.APIURL + "/profil";
    return this.doRequest<any, FormData>(this.urlAPI, ApiMethod.POST, formData);
  }

  editProfileFormData(id: string, params: ProfilFormData) {
    const formData = new FormData();
    if (params.file) {
      formData.append("file", params.file);
    }
    const jsonBlob = new Blob([JSON.stringify(params.data)], {
      type: "application/json",
    });
    formData.append("data", jsonBlob);
    this.urlAPI = this.APIURL + `/profil/${id}`;
    return this.doRequest<any, FormData>(this.urlAPI, ApiMethod.PUT, formData);
  }
}
